<div class="task-item flex items-center font-medium w-full text-sm text-textoGrisOscuro px-2 gap-1">
  <div class="flex items-center bodyMedium w-full">
    <tekman-select
      class="task-item__dropdown w-full"
      placeholder="{{ 'f.generic.exercises' | translate }}"
      [style]="{
        wrapper: 'w-full',
        trigger: 'relative border-grisMedio1 px-4 rounded-lg',
        activities: true,
        container: 'left-0 top-10 right-0',
        placeholder: 'bodyMedium'
      }">
      <ng-container *ngFor="let item of _activity">
        <div
          class="py-2 flex items-center justify-between cursor-pointer hover:bg-fondoGrisClaro custom-items"
          (click)="handleClickStep(item.activity, disabled && !!(item.activity.solutionaryUrl || item.activity.resourceUrl))"
          [ngClass]="{
            'opacity-50 pointer-events-none': (item.activity?.isHidden && !isTeacher) || item.activity?.typologyName === 'master-class'
          }">
          <div class="flex items-center gap-3">
            <svg-icon
              *ngIf="item.activity?.resourceUrl || item.activity?.solutionaryUrl || item.activity?.link"
              [ngClass]="{ 'opacity-50': disabled && (item.activity.solutionaryUrl || item.activity.resourceUrl) }"
              key="download"
              class="aria-hidden"
              size="sm"></svg-icon>

            <span class="bodyMedium" [ngClass]="{ 'opacity-50': disabled && (item.activity.solutionaryUrl || item.activity.resourceUrl) }">
              {{ item.activity?.title }}
              <span *ngIf="item.activity?.solutionaryUrl">({{ 'f.generic.solutionary' | translate }})</span>
            </span>
            <svg-icon *ngIf="item.activity?.isHidden" key="disable-circle" class="aria-hidden -mr-3" size="sm"></svg-icon>
          </div>

          <zero-exercise-status
            *ngIf="item.activity.completedExcercises !== undefined && item.activity.totalExcercises !== undefined"
            [completedExcercises]="item.activity.completedExcercises"
            [totalExcercises]="item.activity.totalExcercises"
            [isSent]="item.activity.isSent"></zero-exercise-status>
        </div>
      </ng-container>
    </tekman-select>
  </div>
</div>
